<template>
  <div>
    <svg
      width="390"
      height="64"
      viewBox="0 0 390 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="mobile"
    >
      <g>
        <rect
          y="44"
          width="12"
          height="20"
          fill="currentColor"
        />

        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M378 44V64H12V44.0043C27.2402 44.1925 41.0102 50.486 50.9773 60.552C69.4017 24.6024 106.828 0 150 0C194.45 0 232.808 26.0804 250.608 63.7736C258.562 42.8606 278.796 28 302.5 28C322.708 28 340.394 38.8005 350.1 54.9441C357.386 48.1542 367.161 44 377.905 44H378Z"
          fill="currentColor"
        />

        <rect
          x="378"
          y="44"
          width="12"
          height="20"
          fill="currentColor"
        />
      </g>
    </svg>

    <svg
      width="768"
      height="96"
      viewBox="0 0 768 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="tablet"
    >
      <g>
        <rect
          y="68"
          width="60"
          height="28"
          fill="currentColor"
        />

        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M708 68V96H60V68H61.9445C83.8783 68 103.843 76.4306 118.775 90.2282C146.519 36.6302 202.482 0 267 0C331.334 0 387.162 36.4225 414.987 89.7721C424.207 85.391 434.521 82.9395 445.408 82.9395C460.68 82.9395 474.826 87.7638 486.404 95.9717C496.639 58.0448 531.283 30.1362 572.445 30.1362C611.806 30.1362 645.206 55.6554 657.004 91.0512C668.216 77.002 685.486 68 704.858 68H708Z"
          fill="currentColor"
        />

        <rect
          x="708"
          y="68"
          width="60"
          height="28"
          fill="currentColor"
        />
      </g>
    </svg>

    <svg
      width="1440"
      height="160"
      viewBox="0 0 1440 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="desktop"
    >
      <g>
        <rect
          y="112"
          width="180"
          height="48"
          fill="currentColor"
        />

        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1260 112V160H180V112H183.241C220.027 112 253.49 126.228 278.426 149.481C324.826 60.641 417.831 0 525 0C632.224 0 725.27 60.7036 771.646 149.619C787.012 142.317 804.202 138.231 822.346 138.231C847.8 138.231 871.376 146.272 890.673 159.953C907.732 96.7414 965.472 50.2275 1034.08 50.2275C1099.33 50.2275 1154.75 92.31 1174.69 150.816C1193.37 127.173 1222.29 112 1254.76 112H1260Z"
          fill="currentColor"
        />

        <rect
          x="1260"
          y="112"
          width="180"
          height="48"
          fill="currentColor"
        />
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'Clouds'
  }
</script>
